import { he } from "date-fns/locale";
import React, { useState } from "react";
import Datepicker from "react-tailwindcss-datepicker";

const CustomDatePicker = ({
  onChange,
  marginStart,
  background,
  width,
  height,
  borderRadius,
  marginBottom,
  marginEnd,
  marginTop,
  placeholder
}) => {
  const [value, setValue] = useState({
    startDate: null,
    endDate: null,
  });

  const handleValueChange = (newValue) => {
    setValue(newValue);
    console.log(newValue);
    onChange(newValue);
  };


  return (
    <div
      style={{
        height:height??'42px',
        width: width ?? "240px",
        marginInlineStart: marginStart ?? "0px",
        marginBottom:marginBottom??'0px',
        marginTop:marginTop??'0px',
        marginInlineEnd:marginEnd??'0px',
        background: background ?? "white",
        border: "1px  solid rgba(0,0,0,0.2)",
        borderRadius: borderRadius ?? "5px"
      }}
    >
      <Datepicker
        primaryColor="red"
        showShortcuts={true}
        value={value}
        onChange={handleValueChange}
        placeholder={placeholder??null}
      />
    </div>
  );
};
export default CustomDatePicker;
